/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

/* eslint-disable global-require */

import React from 'react';
import Register from './Register';

const title = 'Register for an Account';

export default {
  path: '/register',

  action({ store }) {
    const { auth } = store.getState();
    // If user is logged in already, go home
    if (auth.isAuth) {
      return { redirect: '/' };
    }

    return {
      title,
      chunks: ['register'],
      component: <Register title={title} />,
    };
  },
};
